module.exports = __webpack_public_path__ + "src/assets/img/commands-setting.3bf454c5.svg";